import React from 'react';
import { useNavigate } from 'react-router-dom';

interface EditPermissionDeniedProps {
  treeId: string | null;
}

export const EditPermissionDenied: React.FC<EditPermissionDeniedProps> = ({ treeId }) => {
  const navigate = useNavigate();

  const handleReturnToView = () => {
    const targetTreeId = treeId || 'tekken-8';
    navigate(`/tree/${targetTreeId}`);
  };

  return (
    <div className="auth-required">
      <div className="auth-message">
        <h2>Permission Denied</h2>
        <p>You don't have permission to edit this tree.</p>
        <div className="auth-buttons">
          <button 
            className="btn btn-primary"
            onClick={handleReturnToView}
          >
            Return to View Mode
          </button>
        </div>
      </div>
    </div>
  );
};


